import service from '@/utils/request'

/**
 * banner轮播
 */
export function getProductList() {
    return service({
        url: '/api/product/getList',
        method: 'get'
    })
}